import { useSelector } from "react-redux";
import { useGlobalData } from "@redux/slices/globalSlice";
import { useInitialUrl } from "@utils/useInitialUrl";

export const useProductPrefix = (product_type?: string) => {
  const { products } = useGlobalData();
  const activeProduct = useSelector(
    (state: any) => state.appState?.activeProduct
  );
  const { initialUrl } = useInitialUrl();
  const segments = initialUrl?.match(/\/webapp\/([^/]+)/);

  const productPrefix =
    (products && products[product_type || activeProduct]?.product_prefix) ||
    product_type ||
    segments?.[1] ||
    activeProduct;
  return productPrefix;
};
